/**
 * Marker string embedded by the backend's EmailValidationException.
 * Must match EmailValidationException.MARKER on the Java side.
 */
export const EMAIL_VALIDATION_FAILED_MARKER = "EMAIL_VALIDATION_FAILED";

type RpcItem = { error?: { data?: { description?: { default?: string } } } };

/**
 * Returns true when the caught RPC error originates from a backend EmailValidationException.
 *
 * The A12 RPC framework wraps server exceptions into a JsonRpc2Response.error whose user-visible
 * message is stored at error.data.description.default.
 */
export function isEmailValidationFailedError(error: unknown): boolean {
	if (!Array.isArray(error)) {
		return false;
	}
	return (error as RpcItem[]).some(item => {
		const msg = item?.error?.data?.description?.default ?? "";
		return msg.includes(EMAIL_VALIDATION_FAILED_MARKER);
	});
}
